import {ControlPoint} from "./ControlPoint";

export class AnchorPoint extends ControlPoint {
  draw(ctx, screen) {
      ctx.beginPath();
      ctx.arc(screen.x, screen.y, 8, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,0,0,0.85)';
      ctx.fill();
      ctx.lineWidth = 2;
      ctx.strokeStyle = 'white';
      ctx.stroke();
  }
}
